import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b5e3cyh82h: FaireBrandEntity = {
  token: "b_b5e3cyh82h",
  type: "brand",
  name: "Amady Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/531e091d90ef6512afbd03f0d5aca5f07be74f16e094c6c3aa9e8066d2a12c58.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/23e4f0ec5375bfe061c29cf06c18fed4244f3a7ce4f3524c259969d1b802e39f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/531e091d90ef6512afbd03f0d5aca5f07be74f16e094c6c3aa9e8066d2a12c58.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/23e4f0ec5375bfe061c29cf06c18fed4244f3a7ce4f3524c259969d1b802e39f.png",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 39,
  isTopShop: true,
  isInsider: true,
  description:
    '⭑⭑⭑⭑⭑\n\nHello, my name is Zam! I\'m the jewelry maker, mama and military wife behind "Amady Jewelry"  \n\nMy pieces are an ever-changing collection of handmade jewelry inspired by the world around us and the beautiful customers that have been supporting my shop since the beginning of this journey.  Our pieces are designed and handcrafted entirely in the United States by myself, or overseas depending where we are stationed as the military family we are.\n\nJewelry design has been a passion of mine ever since I was a teenager.  I remember spending tons of hours making my own jewelry and getting compliments from friends and family members.  \n\nHere at Amady Jewelry, handpicking the materials is not only my favorite part of the designing process, but I believe is the most important part!  All the materials are handpicked for their luster, color and size making each piece unique and one of a kind. I only use the highest quality precious and semi-precious gemstone beads, pendants, charms, chains...\n\nThank you for being a part of this journey and supporting a dream!',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:21.039Z",
    importedBy: "entity-db-cli",
  },
};
